import React, { useEffect } from "react";
import { useState } from "react";
import { Tabs, Button } from "flowbite-react";
import ExpenseFrom from "../components/Forms/ExpenseForm";
import Inventorytable from "../components/Table/InventoryTable";
import NavigationComponent from "../components/Nav_footer/Navigation";
import axios from "axios";
import FooterComponent from "../components/Nav_footer/Footer";
import InventoryTable from "../components/Table/InventoryTable";
import { useParams } from "react-router-dom";

export default function Iotpage() {
    const params = useParams()
    const [ShowUploadForm, setShowUploadForm] = useState(false);
    const [List, setList] = useState([]);
    const header = "IOT Inventory"
    const catagory = "Qantity"
    const buttonmessage = "Add"
    const name = "Component Name"
    const permission = true
    const mode = useParams.mode


    useEffect(() => {
        axios.post(`${process.env.REACT_APP_SERVER_URL}/api/expenses/getExpenseByUser`, {}, { withCredentials: true })
            .then(result => {
                if (result.status === 200 && result.data.message === "success") {
                    setList(result.data.expenses)
                }
            })
    }, [])
    return (
        <>
            {ShowUploadForm && <ExpenseFrom props={{ ShowUploadForm, setShowUploadForm, List, setList, header, catagory, buttonmessage, name, permission }} />}
            <NavigationComponent />
            <div className="mt-8 my-5">

                <div className="text-center"> <h1 className="font-bold mb-10">Iot Inventory</h1></div>
                <InventoryTable data={{ List,mode }} />
                <div>
                    <div className="flex gap-3 w-fit m-auto mt-10">
                        <div className="items-center m-1" >
                            {mode === "edit" && <Button
                                // disabled= {mode}
                                onClick={() => setShowUploadForm(true)}>
                                Add
                            </Button>}

                        </div>
                    </div>
                </div>

            </div>
            <div className="relative bottom-0 text-center p-8  w-full">
                <FooterComponent />
            </div>

        </>
    )
}